<template>
   <div>
      <main>
         <img src="../public/images/wow-classic-logo.png" class="logo"/>
         <h1 class="main-title">Talent Calculator</h1>
         <ul class="class-list">
            <class-list
                 v-for="classType in data.classes"
                 v-bind:classType="classType"
                 v-bind:key="classType.id"
                 v-on:change-class="data.currentClass = classType.id"
                 v-bind:constants="data.constants"
                 v-on:classChanged="classChanged"
            ></class-list>
         </ul>
         <div class="talent-toolbar">
            <div class="talent-info">
               <p class="talent-info-stat">Skillpoints left: {{ skillPoints }}</p>
               <p class="talent-info-stat">Required level: {{ requiredLevel }}</p>
            </div>
         </div>
         <class-panel
              v-bind:class-type="data.classes[data.currentClass]"
              v-bind:constants="data.constants"
              v-on:talentsChanged2="talentsChanged2"
         ></class-panel>
         <!--      <talent-path v-bind:currentClass="data.classes[data.currentClass]"></talent-path>-->
         <!--      <div class="talent-actions">-->
         <!--        <button class="button" @click="popupImportActive=true">-->
         <!--          <i class="material-icons md-18">cloud_download</i> Import-->
         <!--        </button>-->
         <!--        <button class="button" @click="popupExportChoiceActive=true">-->
         <!--          <i class="material-icons md-18">cloud_upload</i> Export-->
         <!--        </button>-->
         <!--        <button class="button" @click="saveTalentTrees">-->
         <!--          <i class="material-icons md-18">save_alt</i> Save-->
         <!--        </button>-->
         <!--      </div>-->
      </main>
      <footer>
         <p class="footer-info">
            Created by <a style="color: #8dc63f" href="http://www.turtle-wow.org/" target="_blank">Turtle WoW Team</a>
            for
            <a style="color: #2ea9ff" href="https://vanillaplus.org/" target="_blank">Vanilla Plus</a> players.
            <br/>Based on <a style="color: #999" href="https://github.com/iamadagostino/wow-classic-talent-calculator"
                             target="_blank">wow-classic-talent-calculator</a>
         </p>
      </footer>
      <div class="centerx">
         <vs-popup
              class="popup"
              :background-color-popup="colorx"
              title="Import Talents"
              :active.sync="popupImportActive"
         >
            <textarea-autosize
                 placeholder="Paste stuff"
                 v-model="importMessage"
                 :min-height="50"
                 :max-height="350"
            ></textarea-autosize>
            <button class="button" @click="popupImportMessage">
               <i class="material-icons md-18">cloud_download</i> Import
            </button>
         </vs-popup>
         <vs-popup
              class="popup"
              :background-color-popup="colorx"
              title="Export Talents"
              :active.sync="popupExportActive"
         >
            <textarea-autosize
                 ref="textToexport"
                 v-model="exportMessage"
                 :min-height="30"
                 :max-height="350"
            ></textarea-autosize>
            <button class="button" @click="copyTextArea">
               <i class="material-icons" style="vertical-align: middle">assignment</i> Copy
            </button>
         </vs-popup>
         <vs-popup
              class="popup"
              :background-color-popup="colorx"
              title="Export build"
              :active.sync="popupExportChoiceActive"
         >
            <div class="popup-btns">
               <button class="button" @click="popupExportMessageSingle">Export Single</button>
               <button class="button" @click="popupExportMessageAll">Export All</button>
            </div>
         </vs-popup>
      </div>
   </div>
</template>
<script>
    import talentData from "../assets/data/talent-data.json";
    import classList from "./ClassList";
    import classPanel from "./ClassPanel";
    // import talentPath from "./TalentPath";
    let impexpjson = require("jsonpack/main");
    let base64 = require("js-base64").Base64;

    export default {
        components: {
            classList,
            classPanel,
            // talentPath
        },
        data: function () {
            return {
                data: talentData,
                colorx: "#4a5153",
                popupImportActive: false,
                popupExportActive: false,
                popupExportChoiceActive: false,
                importMessage: "",
                exportMessage: ""
            };
        },
        mounted: function () {

            setTimeout(() => {

                if (this.$route.path.length > 3) {
                    let p = this.$route.path;
                    let classEx = p.split('/');
                    let classId = classEx[2];
                    let talentEx = classEx[3].split('-');
                    this.data.currentClass = parseInt(classId);
                    this.data.classes[this.data.currentClass].requiredLevel = 10;
                    this.data.classes[this.data.currentClass].availableSkillPoints = 51;
                    for (let i = 0; i <= 2; i++) {
                        let specPoints = 0;
                        let treeSize = this.data.classes[this.data.currentClass].talentTrees[i].skills.length;
                        // let treeSize = talentEx[i].length ;
                        for (let j = 0; j <= treeSize - 1; j++) {

                            // console.log('checking : ' + this.data.classes[this.data.currentClass].talentTrees[i].skills[j].name);
                            this.data.classes[this.data.currentClass].talentTrees[i].skills[j].currentRank =
                                parseInt(typeof talentEx[i][j] !== "undefined" ? talentEx[i][j] : 0);

                            this.data.classes[this.data.currentClass].availableSkillPoints -=
                                this.data.classes[this.data.currentClass].talentTrees[i].skills[j].currentRank;
                            // this.data.classes[this.data.currentClass].talentTrees[i].skills[j].enabled =
                            //     parseInt(talentEx[i][j]) > 0;
                            this.data.classes[this.data.currentClass].talentTrees[i].skillPoints += parseInt(typeof talentEx[i][j] !== "undefined" ? talentEx[i][j] : 0);

                            specPoints += parseInt(typeof talentEx[i][j] !== "undefined" ? talentEx[i][j] : 0);

                            if (typeof (this.data.classes[this.data.currentClass].talentTrees[i].skills[j].requirements) !== "undefined") {

                                if (typeof (this.data.classes[this.data.currentClass].talentTrees[i].skills[j].requirements.specPoints) !== "undefined") {

                                    this.data.classes[this.data.currentClass].talentTrees[i].skills[j].enabled =
                                        this.data.classes[this.data.currentClass].talentTrees[i].skills[j].requirements.specPoints <= specPoints;

                                }

                                if (typeof (this.data.classes[this.data.currentClass].talentTrees[i].skills[j].requirements.skill) !== "undefined") {

                                    if (typeof (this.data.classes[this.data.currentClass].talentTrees[i].skills[j].requirements.skill.id) !== "undefined") {

                                        for (let k = 0; k <= talentEx[i].length - 1; k++) {
                                            if (this.data.classes[this.data.currentClass].talentTrees[i].skills[j].requirements.skill.id ===
                                                this.data.classes[this.data.currentClass].talentTrees[i].skills[k].id) {

                                                console.log('found one req ' + this.data.classes[this.data.currentClass].talentTrees[i].skills[j].name);

                                                if (this.data.classes[this.data.currentClass].talentTrees[i].skills[j].enabled) {

                                                    console.log(' already enabled ');

                                                    if (this.data.classes[this.data.currentClass].talentTrees[i].skills[j].requirements.skill.skillPoints ===
                                                        this.data.classes[this.data.currentClass].talentTrees[i].skills[k].currentRank) {

                                                        this.data.classes[this.data.currentClass].talentTrees[i].skills[j].enabled = true;

                                                    } else {
                                                        this.data.classes[this.data.currentClass].talentTrees[i].skills[j].enabled = false;
                                                    }

                                                }

                                            }

                                        }

                                    }

                                }


                            }

                        }
                        this.data.classes[this.data.currentClass].requiredLevel += this.data.classes[this.data.currentClass].talentTrees[i].skillPoints;
                        // this.data.classes[this.data.currentClass].availableSkillPoints -= this.data.classes[this.data.currentClass].talentTrees[i].skillPoints;

                    }

                    this.data.classes[this.data.currentClass].requiredLevel--;

                } else {
                    let urlString = '';
                    this.data.classes[this.data.currentClass].requiredLevel = 10;
                    this.data.classes[this.data.currentClass].availableSkillPoints = 51;
                    for (let i = 0; i <= 2; i++) {
                        let treeString = '';
                        for (let j = 0; j <= this.data.classes[this.data.currentClass].talentTrees[i].skills.length - 1; j++) {
                            treeString += '' + this.data.classes[this.data.currentClass].talentTrees[i].skills[j].currentRank;
                        }
                        treeString = treeString.replace(new RegExp("[0]+$"), "");
                        if (treeString === '') treeString = '0';
                        urlString += treeString + '-'
                    }
                    urlString = urlString.replace(new RegExp("[-]+$"), "");
                    this.$router.push('/t/' + this.data.classes[this.data.currentClass].id + '/' + urlString)
                }

            }, 500);


        },
        computed: {
            skillPoints: function () {
                return this.data.classes[this.data.currentClass].availableSkillPoints;
            },
            requiredLevel: function () {
                return this.data.classes[this.data.currentClass].requiredLevel;
            }
        },
        methods: {
            classChanged: function (id) {
                this.data.currentClass = parseInt(id);
                this.data.classes[this.data.currentClass].requiredLevel = 10;
                this.data.classes[this.data.currentClass].availableSkillPoints = 51;

                for (let i = 0; i <= 2; i++) {
                    this.data.classes[this.data.currentClass].talentTrees[i].skillPoints = 0;
                    for (let j = 0; j <= this.data.classes[this.data.currentClass].talentTrees[i].skills.length - 1; j++) {
                        this.data.classes[this.data.currentClass].talentTrees[i].skills[j].currentRank = 0;
                    }
                }
                let urlString = '';
                for (let i = 0; i <= 2; i++) {
                    let treeString = '';
                    for (let j = 0; j <= this.data.classes[this.data.currentClass].talentTrees[i].skills.length - 1; j++) {
                        treeString += '' + this.data.classes[this.data.currentClass].talentTrees[i].skills[j].currentRank;
                    }
                    treeString = treeString.replace(new RegExp("[0]+$"), "");
                    if (treeString === '') treeString = '0';
                    urlString += treeString + '-'
                }
                urlString = urlString.replace(new RegExp("[-]+$"), "");
                this.$router.push('/t/' + this.data.classes[this.data.currentClass].id + '/' + urlString)
            },
            talentsChanged2: function () {

                let urlString = '';

                console.log(this.data.currentClass);

                for (let i = 0; i <= 2; i++) {
                    let treeString = '';
                    for (let j = 0; j <= this.data.classes[this.data.currentClass].talentTrees[i].skills.length - 1; j++) {
                        treeString += '' + this.data.classes[this.data.currentClass].talentTrees[i].skills[j].currentRank;
                    }
                    treeString = treeString.replace(new RegExp("[0]+$"), "");
                    if (treeString === '') treeString = '0';
                    urlString += treeString + '-'
                }
                urlString = urlString.replace(new RegExp("[-]+$"), "");
                this.$router.push('/t/' + this.data.classes[this.data.currentClass].id + '/' + urlString)
            },
            popupImportMessage: function () {
                let importedData = impexpjson.unpack(base64.decode(this.importMessage));
                let joinedData = this.data;
                this.popupImportActive = false;
                this.importMessage = "";
                if (importedData.import == "single") {
                    joinedData.currentClass = importedData.currentClass;
                    joinedData.classes[importedData.currentClass] =
                        importedData.classes[importedData.currentClass];
                    window.localStorage.removeItem("talentsDataImported");
                    window.localStorage.setItem(
                        "talentsDataImported",
                        JSON.stringify(joinedData)
                    );
                } else {
                    window.localStorage.removeItem("talentsDataImported");
                    window.localStorage.setItem(
                        "talentsDataImported",
                        JSON.stringify(importedData)
                    );
                }
                this.data = JSON.parse(
                    window.localStorage.getItem("talentsDataImported")
                );
            },
            popupExportMessageSingle: function () {
                let base64 = require("js-base64").Base64;
                let exportedData = this.data;
                let classData = exportedData.classes[this.data.currentClass];
                this.popupExportChoiceActive = false;
                this.popupExportActive = true;
                exportedData.import = "single";
                for (let i = 0; i < exportedData.classes.length; i++) {
                    if (i !== classData.id) {
                        delete exportedData.classes[i].talentPath;
                        delete exportedData.classes[i].talentTrees;
                    }
                }
                this.exportMessage = base64.encode(impexpjson.pack(exportedData));
            },
            popupExportMessageAll: function () {
                let base64 = require("js-base64").Base64;
                let exportedData = this.data;
                exportedData.import = "all";
                this.popupExportChoiceActive = false;
                this.popupExportActive = true;
                this.exportMessage = base64.encode(impexpjson.pack(exportedData));
            },
            copyTextArea: function () {
                let el = this.$refs.textToexport.$el;
                let elCount = this.$refs.textToexport.$el.value.length;
                let oldContentEditable = el.contentEditable,
                    oldReadOnly = el.readOnly,
                    range = document.createRange();
                let s = window.getSelection();

                el.contentEditable = true;
                el.readOnly = false;
                range.selectNodeContents(el);

                s.removeAllRanges();
                s.addRange(range);

                el.setSelectionRange(0, elCount);

                el.contentEditable = oldContentEditable;
                el.readOnly = oldReadOnly;

                document.execCommand("Copy");
                this.popupExportActive = false;
            },
            saveTalentTrees: function () {
                let localData = JSON.stringify(this.data);
                window.localStorage.setItem("talentsDataSaved", localData);
            }
        }
    };
</script>
